import React from "react";
import { Box, Stack, Typography } from "@mui/material";

export type MiContenidoPageHeaderProps = {
  /** e.g. back link — rendered top-left above the title row */
  aboveTitle?: React.ReactNode;
  identity: React.ReactNode;
  title: React.ReactNode;
  belowTitle?: React.ReactNode;
  actions: React.ReactNode;
};

/**
 * Shared layout for Mi contenido profile and platform detail headers:
 * 128px-scale identity + title + secondary row; filters on the right.
 */
export const MiContenidoPageHeader: React.FC<MiContenidoPageHeaderProps> = ({
  aboveTitle,
  identity,
  title,
  belowTitle,
  actions,
}) => (
  <Stack spacing={1}>
    <Box
      sx={{
        alignSelf: "flex-start",
        lineHeight: 1.2,
        typography: "body2",
        minHeight: "16px",
      }}
    >
      {aboveTitle}
    </Box>
    <Stack
      direction={{ xs: "column", md: "row" }}
      spacing={2}
      alignItems={{ xs: "flex-start", md: "flex-start" }}
      justifyContent="space-between"
    >
      <Stack direction="row" spacing={2} alignItems="center">
        {identity}
        <Box>
          <Typography
            variant="h1"
            component="h1"
            sx={{ fontSize: { xs: "1.5rem", md: "1.75rem" } }}
          >
            {title}
          </Typography>
          {belowTitle != null && belowTitle !== false && (
            <Stack
              direction="row"
              flexWrap="wrap"
              gap={1}
              sx={{ mt: 0.5 }}
              alignItems="center"
            >
              {belowTitle}
            </Stack>
          )}
        </Box>
      </Stack>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1}
        flexWrap="wrap"
        useFlexGap
        flexShrink={0}
        alignItems={{ xs: "stretch", sm: "center" }}
        sx={{ width: { xs: "100%", md: "auto" } }}
      >
        {actions}
      </Stack>
    </Stack>
  </Stack>
);
